<template>
  <div class="classificationlistComponent">
    <breadCrum :breadCrumList="breadCrumList"></breadCrum>
    <div class="w80 mb-80">
      <div class="sort_head">
        <div class="head_box fcl">
          <p class="head_text">分类 ：</p>
          <ul>
            <li
              @click="categoryChange(item)"
              :class="{ active: currentCategory == item.id }"
              v-for="(item, index) in industryList"
              :key="index"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
        <div class="head_box fcl">
          <p class="head_text">省份 ：</p>
          <ul class="head_city">
            <li
              @click="provinceChange(item)"
              :class="{ active: currentProvince == item.name }"
              v-for="(item, index) in provinceList"
              :key="index"
            >
              {{ item.name }}
            </li>
          </ul>
        </div>
      </div>
      <!--条件收索-->
      <div class="box_list">
        <div style="width: 26%">
          <el-input
            placeholder="请输入内容"
            v-model="form.keyword"
            class="input-with-select"
          >
            <el-button
              @click="keywordSearch"
              slot="append"
              icon="el-icon-search"
            ></el-button>
          </el-input>
        </div>
        <div class="fdc" style="width: 38%">
          <p class="wrice">综合排序 ：</p>
          <div class="fdc">
            <el-select
              v-model="form.sort_style"
              clearable
              placeholder="请选择"
              class="mr-10"
            >
              <el-option
                v-for="item in orderOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
            <el-select v-model="form.limit_date" clearable placeholder="请选择">
              <el-option
                v-for="item in dateOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
        </div>
        <div class="fdc" style="width: 32%">
          <p class="wrice">价格 ：</p>
          <div class="fdc seach_box">
            <el-input
              class="prices"
              onkeyup="this.value = this.value.replace(/[^\d.]/g,'')"
              v-model.number="form.minPrice"
              clearable
            ></el-input>
            <el-col class="line" :span="2">-</el-col>
            <el-input
              class="prices mr-20"
              onkeyup="this.value = this.value.replace(/[^\d.]/g,'')"
              v-model.number="form.maxPrice"
              clearable
            ></el-input>

            <el-button @click="priceSearch" class="restBtn">确定</el-button>
          </div>
        </div>
      </div>
      <!--关键字-->
      <div class="seach_text fcl mt-10 keyword">
        <p>关键字 :</p>
        <a
          class="ml-10"
          @click="setKeywords(item)"
          v-for="(item, index) in keywordList"
          :key="index"
          :href="item.link"
        >
          {{ item.name }}
        </a>
      </div>
      <!--列表信息-->
      <div class="fsb mt-30">
        <div class="" style="width:70%;">
          <div class="fdw">
            <div
              class="sort_list"
              @click="toDetail(item)"
              v-for="(item, index) in proList"
              :key="index"
            >
              <div class="sort_img">
                <img :src="item.cover" alt="" />
              </div>
              <div class="clat_list">
                <p class="sort_price">
                  <span>￥</span>
                  <span>{{ item.price }}</span>
                </p>
                <p class="sort_count">
                  <span>浏览量 :</span>
                  <span>{{ item.readcount || 0 }}</span>
                </p>
              </div>
              <p class="sort_title">
                {{ item.title }}
              </p>
              <p class="sort_count fdc mt-10">
                <span>{{ item.companyname }}</span>
                <span>{{ item.address }}</span>
              </p>
            </div>
          </div>
          <!--分页-->
          <Pagination
            v-show="total > 0"
            :total="total"
            :page.sync="listQuery.curPage"
            :limit.sync="listQuery.limit"
            @pageChange="pageChange"
          ></Pagination>
        </div>

        <div style="width: 26%">
          <newsRecommend
            @dataRefresh="getRandomList(5)"
            :newsRecommendObj="newsRecommendObj"
            urlType="supply_detail"
          ></newsRecommend>
          <div class="expert_right">
            <img src="../../assets/images/activity_1.jpg" alt="" />
            <span>广告</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { systemList } from '@/api/company'
import titleHead from "../../common/titleHead";
import newsRecommend from "../../common/newsRecommend";
import { region } from "@/api/coment";
import { getProduct, getDictList } from "@/api/information";
import { getRandomArray ,routerGoNewpage} from "@/utils/index";
import Pagination from "../../components/Pagination";
import breadCrum from "@/common/breadCrum";
export default {
  components: { titleHead, newsRecommend, Pagination,breadCrum ,routerGoNewpage},
  data() {
    return {
      headTitle: "分类",
      isActive: false,
      text: "更多",
      newsRecommendObj: {
        title: "最新供应",
        text: "换一批",
        isImg: false,
        newData: [],
      },
      form: {
        keyword: "",
        sortStyle: "",
        limitDte: "",
        minPrice: "",
        maxPrice: "",
      },

      orderOptions: [
        {
          value: 1,
          label: "价格由高到低",
        },
        {
          value: 2,
          label: "价格由低到高",
        },
        {
          value: 3,
          label: "销量由高到低",
        },
        {
          value: 4,
          label: "销量由低到高",
        },
        {
          value: 5,
          label: "点击量由高到低",
        },
        {
          value: 6,
          label: "点击量由低到高",
        },
      ],
      dateOptions: [
        {
          value: 1,
          label: "一天内",
        },
        {
          value: 2,
          label: "三天内",
        },
        {
          value: 3,
          label: "五天内",
        },
        {
          value: 4,
          label: "十天内",
        },
        {
          value: 5,
          label: "半月内",
        },
        {
          value: 6,
          label: "一月内",
        },
      ],
      currentCategory: "",
      provinceList: [],
      currentProvince: "",
      allProductList: [],
      productList: [],
      listQuery: {
        curPage: 1,
        limit: 6,
      },
      total: 0,
      proList: [],
      keywordList: [],
      industryList:[],
      breadCrumList: [
        { name: "供需平台", url: "/supply_demand" },
      ],

    };
  },
  computed: {

  },
  created() {
    this.currentCategory =this.$route.query.categroyid;
    this.getsystemList();
    this.getKeywordsList();
    this.getRegion();
    this.getProduct();
    this.productFilter();
  },
  methods: {
    setKeywords(item) {
      // this.form.keyword = item.name;
    },
    //查询供需三级分类
    getsystemList() {
     systemList().then((res)=>{
       this.industryList = res.data;
       let name = this.industryList.filter(item=>{
         return item.id == this.currentCategory;
       })[0].name;
       this.breadCrumList.push({name})
     }).catch((err)=>{})

    },
    //获取关键字列表
    getKeywordsList() {
      getDictList({
        code: "",
      }).then((res) => {
        this.keywordList = res.data[3].children;
      });
    },
    toDetail(item) {
      routerGoNewpage("/supply_detail",{ id: item.id });
    },
    //获取产品，产品筛选
    productFilter() {
      getProduct({
        ...this.listQuery,
        ...this.form,
        categoryId: this.currentCategory,
        address: this.currentProvince,
      }).then((res) => {
        if(res.code == 0){
          this.proList = res.page.list;
          this.total = res.page.totalCount;
        }
      });
    },
    //获取最新供应
    getProduct() {
      getProduct({
        curPage: 1,
        limit: 10,
        recommend: 1,
        sourcetype: 1,
      }).then((res) => {
        if(res.code == 0){
          this.allProductList = res.page.list;
          this.getRandomList(5);
        }
      });
    },
    getRandomList(length) {
      this.newsRecommendObj.newData = _.compact(
        getRandomArray(_.cloneDeep(this.allProductList), length)
      );
    },
    //获取省份
    getRegion() {
      region().then((res) => {
        if(res.code ==0){
          this.provinceList = res.data;
        }
      });
    },
    provinceChange(item) {
      this.currentProvince = item.name;
      this.productFilter();
    },
    //分类选取产品
    categoryChange(item) {
      this.currentCategory = item.id;
      this.listQuery.curPage = 1 ;
      this.productFilter();
    },
    keywordSearch() {
      this.productFilter();
    },
    priceSearch() {
      // if (null===this.form.minPrice || null===this.form.maxPrice) {
      //   this.$message({
      //     message: "请输入价格范围",
      //     type: "error",
      //   });
      //   return;
      // }
      if ( 0!=this.form.minPrice && 0!=this.form.maxPrice && this.form.maxPrice <= this.form.minPrice) {
        this.$message({
          message: "最高价格需大于最低价格",
          type: "error",
        });
        return;
      }
      this.productFilter();
    },
    //折叠与展开
    onOpen(data) {
      if (data == false) {
        this.isActive = true;
        this.text = "收起";
      } else {
        this.isActive = false;
        this.text = "更多";
      }
    },
    //分页
    pageChange(item) {
      this.listQuery["curPage"] = item.page;
      this.listQuery["limit"] = item.limit;
      this.productFilter();
    },
  },
};
</script>
<style scoped lang="less">
.classificationlistComponent /deep/.el-select .el-input .el-select__caret {
  line-height: 33px;
}
.pagination-container {
  margin: 0 auto;
}
.fcl {
  display: flex;
  justify-content: left;
}
.fsb {
  display: flex;
  justify-content: space-between;
}
.f1 {
  flex: 1;
}
.mb-80 {
  margin-bottom: 80px;
}
.ml-10 {
  margin-left: 10px;
}
.ml-20 {
  margin-left: 20px;
}
.ml-30 {
  margin-left: 30px;
}
.ml-60 {
  margin-left: 60px;
}
.mt-10 {
  margin-top: 10px;
}
.mt-30 {
  margin-top: 30px;
}
.mr-10 {
  margin-right: 10px;
}
.mr-20 {
  margin-right: 20px;
}

.clat_list{
  display: flex;
  flex-direction: column;
}

/deep/.seach_box  .el-button--default:hover{
   background: #3bae30;
   color: #ffffff;
}

.sort_head {
  border: 1px solid #dcdcdc;
  .head_box:last-child {
    border-bottom: none;
  }
}
.head_box {
  padding: 15px 10px 10px 10px;
  border-bottom: 1px dashed #dcdcdc;
  ul {
    display: flex;
    margin-left: 20px;
    li {
      font-size: 12px;
      font-family: Microsoft YaHei;
      font-weight: 400;
      padding: 0 10px;
      height: 25px;
      line-height: 25px;
      color: #999999;
      cursor: pointer;
      width: 120px;
      display: inline-block;
      margin-right: 30px;
      margin-bottom: 5px;
      &.active {
        text-align: center;
        background: #3bae30;
        border-radius: 3px;
        color: #ffffff !important;
      }
    }
  }
}
.head_text {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}

.active_color {
  width: 52px;
  height: 25px;
  line-height: 25px;
  background: #3bae30;
  border-radius: 3px;
  text-align: center;
  color: #ffffff !important;
}
.head_cox {
  padding: 10px 10px;
  display: flex;
  justify-content: left;
  position: relative;
}
.box_button {
  position: absolute;
  top: 45px;
  right: 20px;
}
.head_city {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  width: 90%;
  text-align: left;
  margin-left: 7px;
}
.head_city p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  width: 52px;
  height: 25px;
  line-height: 25px;
  margin-bottom: 10px;
  margin-right: 20px;
  text-align: center;
}

.head_city p:hover {
  cursor: pointer;
}
.head_citys {
  display: flex;
  justify-content: left;
  flex-wrap: wrap;
  width: 1080px;
}
.head_citys p {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  padding-bottom: 15px;
  margin-right: 30px;
}

.open {
  background: #ffffff;
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
}
.box_list {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 20px;
  flex-wrap: wrap;
}
.box_list/deep/.el-select > .el-input {
  font-size: 13px;
}
.box_list/deep/.el-input-group > .el-input__inner {
  height: 33px;
}
.box_list/deep/.input-with-select {
  /* width: 315px; */
  font-size: 13px;
}
.box_list/deep/.el-input-group__append {
  background: #3bae30 !important;
  color: #ffffff !important;
  width: 61px !important;
  height: 33px !important;
}
.box_list/deep/.el-input--suffix .el-input__inner {
  height: 33px;
}
.box_list/deep/.prices {
  /* width:107px; */
  height: 33px !important;
  font-size: 12px;
}
.box_list/deep/.el-col-2 {
  width: 2.33333%;
}
.seach_text a:hover {
  color: #333333;
  cursor: pointer;
}
.seach_text a{
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}

.keyword p {
  font-size: 12px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.wrice {
  font-size: 13px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  width: 90px;
  margin-right: -10px;
}
.restBtn {
  width: 178px;
  height: 33px;
  background: #3bae30;
  border-radius: 3px;
  color: #ffffff;
  font-size: 14px;
  line-height: 1px;
  border: none;
}

.sort_list {
  width: 30%;
  margin-bottom: 30px;
  cursor: pointer;
  margin-right: 25px;
  height: 300px;
}
.sort_img {
  overflow: hidden;
}
.sort_img img {
  width: 100%;
  height: 184px;
  transition: all 0.6s;
}
.sort_img img:hover {
  transform: scale(1.4);
}
.sort_price {
  color: #ff7302;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: normal;
}
.sort_price span:nth-child(2) {
  font-size: 18px;
}
.sort_count span {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
}
.sort_count span:nth-child(1){
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  max-width: 85%;
}
.sort_title {
  margin-top: 8px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  display: inline-block;
  width: 100%;
  overflow: hidden;
  text-overflow:ellipsis;
  white-space: nowrap;
}
.expert_right {
  margin-top: 10px;
  position: relative;
}
.expert_right img {
  width: 100%;
  height: 184px;
}
.expert_right span {
  position: absolute;
  top: 10px;
  left: 10px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #ffffff;
}
.el-pagination {
  margin-top: 40px;
  margin-left: 16%;
}
</style>



// WEBPACK FOOTER //
// src/view/home/classification_list.vue